export enum SchedulerEventType {
  Hearing = 1,
  Reserved = 2,
  LunchHours = 4,
  Urgent = 5,
  Adjournment = 1,
}
